import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'fnsr-presentation',
  standalone: true,
  templateUrl: './presentation.component.html'
})
export class PresentationComponent {

  public showingAgentsLife = true;
  public showingHowTo = false;
  public showingTrackRecord = false;

  selected = new FormControl(0);

  // aboutMeFacts: string[] = [
  //   '- Raphael Gruber (38) aus Karlsruhe',
  //   '- Seit 20 Jahren als Versicherungsmittler tätig',
  //   '- Davon 18 Jahre für die Barmenia als § HGB 84',
  //   '- Ausbildung bei der Barmenia zum Versicherungsfachmann (BWV)',
  //   '- Seit meiner Jugend begleiten mich die Themen Finanzen und IT'
  // ];

  // experiences: string[] = [
  //   '- mit eigenem Büro (Zeitraum: 5 Jahre)',
  //   '- mit einer Vertriebsassistenz ',
  //   '- mit einem Auszubildenden (Kaufmann für Versicherungen und Finanzen)',
  //   '- mit einem Agenturpartner',
  //   '- mit den täglichen Herausforderungen eines Versicherungsvermittlers (Wir sitzen im selben Boot)'
  // ];

  // motivations: string[] = [
  //   '> Meine Motivation: Dauerhaft Mehr Zeit und/oder mehr Geld zu erhalten',
  //   '> Gut: Denselben Umsatz mit geringerem Zeitaufwand',
  //   '> Besser: Mehr Umsatz mit demselben Zeitaufwand',
  //   '> Optimal: Mehr Umsatz mit geringerem Zeitaufwand',
  //   '=> Wenn ein Tool dies nicht ermöglicht, ist es sein Geld nicht wert!',
  // ];

  // targets: string[] = [
  //   '- Systematisch dauerhaft hohe Qualität sicherstellen (auch bei Ausführung durch Andere)',
  //   '- Prozesse / Abläufe / Routinen automatisieren, um (zeitraubende) Handarbeit zu vermeiden',
  //   '- Vielfältige werbliche Medienelemente kombinieren (Angler -> Wurm -> Fisch)',
  //   '- Aktualität der werblichen Medienelemente (z.B. Prospekte, Siegel, Online-Abschlüsse)',
  //   '- Einsetzbarkeit bei Interessenten (z.B. Leads) als auch bei Bestandskunden',
  // ];

  // results1: string[] = [
  // '- Kundin seit Monaten auf Wiedervorlage.',
  // '- Sie hat praktisch keine Zeit für die Unterlagen oder ein Gespräch',
  // '- E-Mail über finsuro.mail versandt. Sie wählt das Video aus und ist in 2 Minuten informiert',
  // '- Sie meldet sich von sich selbst und möchte den Zahnschutz haben. Wir nehmen den Antrag auf',
  // '=> Sie hat die Medienelemente angesehen, die Sie angesprochen haben. Online-Abschluss gehört nicht dazu',
  // ];

  // results2: string[] = [
  //   '14:37 Lead vom 01.07.2020 für 15 € - 63-jähriger Mann, stationärer Schutz ',
  //   '14:45 E-Mail über finsuro.mail ging an ihn raus',
  //   '14:53 Telefonischen Erstkontakt hergestellt (Dauer: 34 Minuten) und Fragen geklärt',
  //   '15:37 (exakt 1 Stunde nach dem Kauf des Leads) trudelt der Online-Abschluss ein',
  //   '=> 70,10 € für 15 € Leadkosten und ca. 45 Minuten investierte Zeit',
  // ];

  // results3: string[] = [
  //   'Apotheker',
  //   '- So Nachmittag Anfrage ohne TEL, daher günstiger Lead 10 €',
  //   '- Mail über fnsr.M&M geschickt mit Erstinfo und Hinweis auf Kontaktaufnahme wg. Fehlender Telefonnummer',
  //   '- Mo Vormittag Anruf wg. Weiteren Fragen, ca 1-2 Stunden später Online-Abschluss mit ca. 85 AE',
  //   '=> ',
  // ];

  // results4: string[] = [
  //   'Anfrage zu Zahnzusatz o.Telefon',
  //   '- Erstinfo mit Bitte um Rückfmeldung versandt, Lead 10 €',
  //   '- Nachfassen mit Angebotsübersicht',
  //   '- Ruckmeldung, dass OA bereits erfolgt ist, jedoch noch Interesse an einer BU besteht mit Mitteilung Telefonnummer',
  //   '- Termin für Online - Beratung vereinbart',
  //   '=> ',
  // ];

  // typesOfFeatures: string[] = ['Zeitgewinn', 'Rechtschreibprüfung', '', '', ''];

  public showAgentsLife(): void {
    this.showingAgentsLife = true;
    this.showingHowTo = false;
    this.showingTrackRecord = false;
  }

  public showHowto(): void {
    this.showingAgentsLife = false;
    this.showingHowTo = true;
    this.showingTrackRecord = false;
  }

  public showTrackRecord(): void {
    this.showingAgentsLife = false;
    this.showingHowTo = false;
    this.showingTrackRecord = true;
  }
}
